__turbopack_context__.v({
  "accountButton": "onboarding-module__iMb0na__accountButton",
  "accountButtonPrimary": "onboarding-module__iMb0na__accountButtonPrimary",
  "accountChartDetail": "onboarding-module__iMb0na__accountChartDetail",
  "accountChartGlyph": "onboarding-module__iMb0na__accountChartGlyph",
  "accountChartInfo": "onboarding-module__iMb0na__accountChartInfo",
  "accountChartSign": "onboarding-module__iMb0na__accountChartSign",
  "accountPerk": "onboarding-module__iMb0na__accountPerk",
  "accountPerkCheck": "onboarding-module__iMb0na__accountPerkCheck",
  "accountPerks": "onboarding-module__iMb0na__accountPerks",
  "accountSummary": "onboarding-module__iMb0na__accountSummary",
  "accountSummaryLabel": "onboarding-module__iMb0na__accountSummaryLabel",
  "accountSummaryRow": "onboarding-module__iMb0na__accountSummaryRow",
  "accountThumb": "onboarding-module__iMb0na__accountThumb",
  "accountThumbs": "onboarding-module__iMb0na__accountThumbs",
  "actions": "onboarding-module__iMb0na__actions",
  "backButton": "onboarding-module__iMb0na__backButton",
  "billingSave": "onboarding-module__iMb0na__billingSave",
  "billingToggle": "onboarding-module__iMb0na__billingToggle",
  "billingToggleActive": "onboarding-module__iMb0na__billingToggleActive",
  "billingToggleBtn": "onboarding-module__iMb0na__billingToggleBtn",
  "birthField": "onboarding-module__iMb0na__birthField",
  "birthForm": "onboarding-module__iMb0na__birthForm",
  "choice": "onboarding-module__iMb0na__choice",
  "choiceActive": "onboarding-module__iMb0na__choiceActive",
  "choiceCheck": "onboarding-module__iMb0na__choiceCheck",
  "choiceEmoji": "onboarding-module__iMb0na__choiceEmoji",
  "choiceLabel": "onboarding-module__iMb0na__choiceLabel",
  "choiceList": "onboarding-module__iMb0na__choiceList",
  "comparisonCell": "onboarding-module__iMb0na__comparisonCell",
  "comparisonCheck": "onboarding-module__iMb0na__comparisonCheck",
  "comparisonCross": "onboarding-module__iMb0na__comparisonCross",
  "comparisonRow": "onboarding-module__iMb0na__comparisonRow",
  "comparisonRowHeader": "onboarding-module__iMb0na__comparisonRowHeader",
  "comparisonStat": "onboarding-module__iMb0na__comparisonStat",
  "comparisonStatLabel": "onboarding-module__iMb0na__comparisonStatLabel",
  "comparisonStatNum": "onboarding-module__iMb0na__comparisonStatNum",
  "comparisonTable": "onboarding-module__iMb0na__comparisonTable",
  "container": "onboarding-module__iMb0na__container",
  "dataCollectedBadge": "onboarding-module__iMb0na__dataCollectedBadge",
  "demoCount": "onboarding-module__iMb0na__demoCount",
  "demoIntro": "onboarding-module__iMb0na__demoIntro",
  "eyebrow": "onboarding-module__iMb0na__eyebrow",
  "fontDisplay": "onboarding-module__iMb0na__fontDisplay",
  "glassCard": "onboarding-module__iMb0na__glassCard",
  "lead": "onboarding-module__iMb0na__lead",
  "moon": "onboarding-module__iMb0na__moon",
  "orbitLine": "onboarding-module__iMb0na__orbitLine",
  "orbitLineSecondary": "onboarding-module__iMb0na__orbitLineSecondary",
  "orbitScene": "onboarding-module__iMb0na__orbitScene",
  "paywallHeadline": "onboarding-module__iMb0na__paywallHeadline",
  "paywallLogo": "onboarding-module__iMb0na__paywallLogo",
  "paywallTestimonial": "onboarding-module__iMb0na__paywallTestimonial",
  "paywallTrialBadge": "onboarding-module__iMb0na__paywallTrialBadge",
  "paywallWrap": "onboarding-module__iMb0na__paywallWrap",
  "permBullet": "onboarding-module__iMb0na__permBullet",
  "permBulletIcon": "onboarding-module__iMb0na__permBulletIcon",
  "permBullets": "onboarding-module__iMb0na__permBullets",
  "permIllustration": "onboarding-module__iMb0na__permIllustration",
  "planCard": "onboarding-module__iMb0na__planCard",
  "planCardActive": "onboarding-module__iMb0na__planCardActive",
  "planCardBadge": "onboarding-module__iMb0na__planCardBadge",
  "planCardFeature": "onboarding-module__iMb0na__planCardFeature",
  "planCardFeatures": "onboarding-module__iMb0na__planCardFeatures",
  "planCardHeader": "onboarding-module__iMb0na__planCardHeader",
  "planCardName": "onboarding-module__iMb0na__planCardName",
  "planCardPrice": "onboarding-module__iMb0na__planCardPrice",
  "planCardPricePeriod": "onboarding-module__iMb0na__planCardPricePeriod",
  "planCardTagline": "onboarding-module__iMb0na__planCardTagline",
  "planCards": "onboarding-module__iMb0na__planCards",
  "planet": "onboarding-module__iMb0na__planet",
  "planetOne": "onboarding-module__iMb0na__planetOne",
  "planetTwo": "onboarding-module__iMb0na__planetTwo",
  "prefActive": "onboarding-module__iMb0na__prefActive",
  "prefCard": "onboarding-module__iMb0na__prefCard",
  "prefGrid": "onboarding-module__iMb0na__prefGrid",
  "prefIcon": "onboarding-module__iMb0na__prefIcon",
  "prefLabel": "onboarding-module__iMb0na__prefLabel",
  "primaryButton": "onboarding-module__iMb0na__primaryButton",
  "processingCenter": "onboarding-module__iMb0na__processingCenter",
  "processingLabel": "onboarding-module__iMb0na__processingLabel",
  "processingRing": "onboarding-module__iMb0na__processingRing",
  "processingRingSvg": "onboarding-module__iMb0na__processingRingSvg",
  "processingSteps": "onboarding-module__iMb0na__processingSteps",
  "processingSub": "onboarding-module__iMb0na__processingSub",
  "processingWrap": "onboarding-module__iMb0na__processingWrap",
  "progressFill": "onboarding-module__iMb0na__progressFill",
  "progressTrack": "onboarding-module__iMb0na__progressTrack",
  "pulseGlow": "onboarding-module__iMb0na__pulseGlow",
  "ritualFloat": "onboarding-module__iMb0na__ritualFloat",
  "ritualGlyph": "onboarding-module__iMb0na__ritualGlyph",
  "ritualGlyphRing": "onboarding-module__iMb0na__ritualGlyphRing",
  "ritualGlyphSymbol": "onboarding-module__iMb0na__ritualGlyphSymbol",
  "ritualInput": "onboarding-module__iMb0na__ritualInput",
  "ritualLayout": "onboarding-module__iMb0na__ritualLayout",
  "ritualPulse": "onboarding-module__iMb0na__ritualPulse",
  "ritualSpin": "onboarding-module__iMb0na__ritualSpin",
  "sceneCaption": "onboarding-module__iMb0na__sceneCaption",
  "screen": "onboarding-module__iMb0na__screen",
  "secondaryButton": "onboarding-module__iMb0na__secondaryButton",
  "shareButton": "onboarding-module__iMb0na__shareButton",
  "shell": "onboarding-module__iMb0na__shell",
  "signBadge": "onboarding-module__iMb0na__signBadge",
  "signBadgeGlyph": "onboarding-module__iMb0na__signBadgeGlyph",
  "signBadgeText": "onboarding-module__iMb0na__signBadgeText",
  "solutionFix": "onboarding-module__iMb0na__solutionFix",
  "solutionIcon": "onboarding-module__iMb0na__solutionIcon",
  "solutionItem": "onboarding-module__iMb0na__solutionItem",
  "solutionList": "onboarding-module__iMb0na__solutionList",
  "solutionPain": "onboarding-module__iMb0na__solutionPain",
  "spinSlow": "onboarding-module__iMb0na__spinSlow",
  "starField": "onboarding-module__iMb0na__starField",
  "starsRow": "onboarding-module__iMb0na__starsRow",
  "tarotCard": "onboarding-module__iMb0na__tarotCard",
  "tarotCardFace": "onboarding-module__iMb0na__tarotCardFace",
  "tarotCardMeaning": "onboarding-module__iMb0na__tarotCardMeaning",
  "tarotCardName": "onboarding-module__iMb0na__tarotCardName",
  "tarotCardPos": "onboarding-module__iMb0na__tarotCardPos",
  "tarotCardSelected": "onboarding-module__iMb0na__tarotCardSelected",
  "tarotSpread": "onboarding-module__iMb0na__tarotSpread",
  "testimonial": "onboarding-module__iMb0na__testimonial",
  "testimonialAvatar": "onboarding-module__iMb0na__testimonialAvatar",
  "testimonialBody": "onboarding-module__iMb0na__testimonialBody",
  "testimonialHeader": "onboarding-module__iMb0na__testimonialHeader",
  "testimonialName": "onboarding-module__iMb0na__testimonialName",
  "testimonialTag": "onboarding-module__iMb0na__testimonialTag",
  "testimonials": "onboarding-module__iMb0na__testimonials",
  "textLink": "onboarding-module__iMb0na__textLink",
  "tinderButton": "onboarding-module__iMb0na__tinderButton",
  "tinderButtonNo": "onboarding-module__iMb0na__tinderButtonNo",
  "tinderButtonYes": "onboarding-module__iMb0na__tinderButtonYes",
  "tinderButtons": "onboarding-module__iMb0na__tinderButtons",
  "tinderCard": "onboarding-module__iMb0na__tinderCard",
  "tinderCardGhost": "onboarding-module__iMb0na__tinderCardGhost",
  "tinderCardSwipedLeft": "onboarding-module__iMb0na__tinderCardSwipedLeft",
  "tinderCardSwipedRight": "onboarding-module__iMb0na__tinderCardSwipedRight",
  "tinderCount": "onboarding-module__iMb0na__tinderCount",
  "tinderQuote": "onboarding-module__iMb0na__tinderQuote",
  "tinderStack": "onboarding-module__iMb0na__tinderStack",
  "title": "onboarding-module__iMb0na__title",
  "valueCardGlyph": "onboarding-module__iMb0na__valueCardGlyph",
  "valueCardMeaning": "onboarding-module__iMb0na__valueCardMeaning",
  "valueCardName": "onboarding-module__iMb0na__valueCardName",
  "valueCardRow": "onboarding-module__iMb0na__valueCardRow",
  "valueCardText": "onboarding-module__iMb0na__valueCardText",
  "valueCards": "onboarding-module__iMb0na__valueCards",
  "valueGlyph": "onboarding-module__iMb0na__valueGlyph",
  "valueHeader": "onboarding-module__iMb0na__valueHeader",
  "valueOutput": "onboarding-module__iMb0na__valueOutput",
  "valueReading": "onboarding-module__iMb0na__valueReading",
  "valueSubtitle": "onboarding-module__iMb0na__valueSubtitle",
  "valueTitle": "onboarding-module__iMb0na__valueTitle",
  "welcomeCopy": "onboarding-module__iMb0na__welcomeCopy",
  "welcomeLayout": "onboarding-module__iMb0na__welcomeLayout",
  "zodiacReveal": "onboarding-module__iMb0na__zodiacReveal",
  "zodiacRevealGlyph": "onboarding-module__iMb0na__zodiacRevealGlyph",
  "zodiacRevealText": "onboarding-module__iMb0na__zodiacRevealText",
});
